import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import * as httpClient from "../../util/httpClient";
import moment from "moment-timezone";
import { DialogComponent } from "../common/DialogComponent";
import PaymentHistoryDetailViewDialog from "../Dialogs/PaymentHistoryDetailViewDialog";
import * as service from "../../store/service";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { useTranslation } from "react-i18next";

interface IState {
    paymentHistory: any;
    showPaymnetDetails: boolean;
    paymentInfo: any;
    isLoading: boolean;
}

const PaymentHistory: React.FunctionComponent = () => {
    const [state, setState] = useState<IState>({ paymentHistory: [], isLoading: false, showPaymnetDetails: false, paymentInfo: {} });
    const [isIDFUser, setIsIDFUser] = useState(false);
    const [isIDFFlagLoading, setIsIDFFlagLoading] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const { t: tLang } = useTranslation();

    useEffect(() => {
        setIsIDFFlagLoading(true);
        service
            .isIdfUser()
            .then((data) => {
                setIsIDFFlagLoading(false);
                setIsIDFUser(data);
            })
            .catch(() => {
                setIsIDFFlagLoading(false);
            });

        setState({ ...state, isLoading: true });
        httpClient.sendRequest("GET", `api/paymentInfo/getPaymentHistoryDetails`).then((data: any) => {
            if (data.paymentHistory) {
                setState({ ...state, paymentHistory: data.paymentHistory, isLoading: false });
                return;
            }
            setState({ ...state, isLoading: false });
        });
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    const setDialog = (paymentInfo: any) => {
        setState({ ...state, showPaymnetDetails: true, paymentInfo: paymentInfo });
    };

    const handleCloseDialog = () => {
        setState({ ...state, showPaymnetDetails: false });
    };

    return (
        <React.Fragment>
            <div className="row middle-xs">
                <div className="col-xs flex-grow-null">
                    <Link
                        to="/"
                        className="btn-default btn-back"
                        onClick={(e) => {
                            e.preventDefault();
                            history.push({
                                pathname: "/manage-account/my-account",
                                state: {
                                    fromBillingPage: true,
                                },
                            });
                        }}
                    >
                        <span className="btn-icon">
                            <em className="las la-undo"></em>
                        </span>
                        <span className="btn-text sr-only">{tLang("manageAccount.myAccount.billing.paymentHistory.backToPrevious")}</span>
                    </Link>
                </div>
                <div className="col-xs">
                    <h1 className="title-page" id="title-payment-history" tabIndex={-1}>
                        {tLang("manageAccount.myAccount.billing.paymentHistory.tabTitle")}
                    </h1>
                </div>
            </div>

            <div className="row" id="content">
                <div className="col-xs">
                    <div className={state.isLoading || isIDFFlagLoading ? "box  offset-padding loading" : "box offset-padding"}>
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon" aria-hidden="true">
                                    <RenderIcons iconName="history" />
                                </div>
                                <div className="box-title-text has-actions">
                                    <h2 className="box-title">{tLang("manageAccount.myAccount.billing.paymentHistory.title")}</h2>
                                </div>
                            </div>
                        </div>
                        {state.paymentHistory.length > 0 ? (
                            <div className="box-content">
                                <p>{tLang("manageAccount.myAccount.billing.paymentHistory.recentTransactions")}</p>
                                <div className="margin-bottom-s"></div>
                                <div className="table-container scroll">
                                    <table className="m-table-generic">
                                        <caption className="sr-only">{tLang("manageAccount.myAccount.billing.paymentHistory.tabTitle")}</caption>
                                        <thead>
                                            <tr>
                                                <th scope="col">{tLang("manageAccount.myAccount.billing.paymentHistory.label.paymentDate")}</th>
                                                <th scope="col">{tLang("manageAccount.myAccount.billing.paymentHistory.label.price")}</th>
                                                <th scope="col">{tLang("manageAccount.myAccount.billing.paymentHistory.label.paymentMethod")}</th>
                                                <th scope="col">{tLang("manageAccount.myAccount.billing.paymentHistory.label.details")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {state.paymentHistory.map((paymentInfo: any) => (
                                                <tr>
                                                    <td>{moment(paymentInfo.date).format("MM/DD/YYYY")}</td>
                                                    <td>{paymentInfo.amount}</td>
                                                    <td>{paymentInfo.paymentMethod}</td>
                                                    <td>
                                                        <p>
                                                            <span className="default_link" onClick={() => setDialog(paymentInfo)}>
                                                                <a href="javascript:void(0)" className="default_link">
                                                                    {tLang("manageAccount.myAccount.billing.paymentHistory.label.view")}
                                                                </a>
                                                            </span>
                                                        </p>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ) : (
                            <div className="row" id="content" style={{ minHeight: "170px", backgroundColor: "#FFF" }}>
                                <div className="box" style={{ width: "100%" }}>
                                    <div className="box-header col-xs-12 col-sm-12">
                                        <div className="content-sub-title text-align-center">
                                            <div className="monitoring-alert-icon" style={{ fontSize: "40px" }}>
                                                <em className="las la-exclamation-circle "></em>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box-content text-align-center">
                                        <p>{tLang("manageAccount.myAccount.billing.paymentHistory.noHistory")}</p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {state.showPaymnetDetails && (
                <DialogComponent dialogId="alert-details-dialog" title="Alert Details" closeDialog={handleCloseDialog}>
                    <PaymentHistoryDetailViewDialog paymentInfo={state.paymentInfo} isIDFUser={isIDFUser} handleClose={handleCloseDialog} />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default PaymentHistory;
